export default __webpack_public_path__ + "static/media/outsourcing-icon2.dfd80889.svg";